export const AYS_INEK_YEARS: number[] = [
  2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022,
  2023, 2024, 2025, 2026
];
export const AYS_INEK_YEARS_LATEST = AYS_INEK_YEARS[AYS_INEK_YEARS.length - 1];
